"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PopperContainer = void 0;
var _Portal = _interopRequireDefault(require("react-overlays/Portal"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var PopperContainer = exports.PopperContainer = function PopperContainer(_ref) {
  var children = _ref.children,
    customContainer = _ref.customContainer;
  return /*#__PURE__*/_react.default.createElement(_Portal.default, {
    container: customContainer
  }, children);
};
PopperContainer.displayName = 'PopperContainer';
PopperContainer.propTypes = {
  children: _propTypes.default.node,
  customContainer: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object])
};
var _default = exports.default = PopperContainer;